export const FETCH_CART_REQUEST = 'FETCH_CART_REQUEST'
export const FETCH_CART_SUCCESS = 'FETCH_CART_SUCCESS'
export const FETCH_CART_ERROR = 'FETCH_CART_ERROR'

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST'
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS'
export const ADD_TO_CART_ERROR = 'ADD_TO_CART_ERROR'
export const ERR_SHIPPING_SERVICE_UNAVAILABLE = 'ERR_SHIPPING_SERVICE_UNAVAILABLE'
export const CART_ITEM_OUT_OF_STOCK = 'CART_ITEM_OUT_OF_STOCK'

export const NO_SIZE_SELECTED_ERROR = 'NO_SIZE_SELECTED_ERROR'

export const REMOVE_ITEM_REQUEST = 'REMOVE_ITEM_REQUEST'
export const REMOVE_ITEM_SUCCESS = 'REMOVE_ITEM_SUCCESS'
export const REMOVE_ITEM_ERROR = 'REMOVE_ITEM_ERROR'

export const REMOVE_ITEMS_REQUEST = 'REMOVE_ITEMS_REQUEST'
export const REMOVE_ITEMS_SUCCESS = 'REMOVE_ITEMS_SUCCESS'
export const REMOVE_ITEMS_ERROR = 'REMOVE_ITEMS_ERROR'

export const UNDO_REMOVE_ITEM_REQUEST = 'UNDO_REMOVE_ITEM_REQUEST'
export const UNDO_REMOVE_ITEM_SUCCESS = 'UNDO_REMOVE_ITEM_SUCCESS'
export const UNDO_REMOVE_ITEM_ERROR = 'UNDO_REMOVE_ITEM_ERROR'

export const DISMISS_REMOVE_ITEM = 'DISMISS_REMOVE_ITEM'

export const SET_QUANTITY_REQUEST = 'SET_QUANTITY_REQUEST'
export const SET_QUANTITY_SUCCESS = 'SET_QUANTITY_SUCCESS'
export const SET_QUANTITY_ERROR = 'SET_QUANTITY_ERROR'

export const UPDATE_LINE_ITEM_REQUEST = 'UPDATE_LINE_ITEM_REQUEST'
export const UPDATE_LINE_ITEM_SUCCESS = 'UPDATE_LINE_ITEM_SUCCESS'
export const UPDATE_LINE_ITEM_ERROR = 'UPDATE_LINE_ITEM_ERROR'
export const UPDATE_LINE_ITEM_IN_BASKET_ERROR = 'UPDATE_LINE_ITEM_IN_BASKET_ERROR'

export const FETCH_PRODUCT_DETAILS_REQUEST = 'FETCH_PRODUCT_DETAILS_REQUEST'
export const FETCH_PRODUCT_DETAILS_SUCCESS = 'FETCH_PRODUCT_DETAILS_SUCCESS'
export const FETCH_PRODUCT_DETAILS_ERROR = 'FETCH_PRODUCT_DETAILS_ERROR'

export const SET_SELECTED_VARIANT = 'SET_SELECTED_VARIANT'

export const ADD_PROMOTION_REQUEST = 'ADD_PROMOTION_REQUEST'
export const ADD_PROMOTION_SUCCESS = 'ADD_PROMOTION_SUCCESS'
export const ADD_PROMOTION_ERROR = 'ADD_PROMOTION_ERROR'

export const FETCH_PROMOTIONS_REQUEST = 'FETCH_PROMOTIONS_REQUEST'
export const FETCH_PROMOTIONS_SUCCESS = 'FETCH_PROMOTIONS_SUCCESS'
export const FETCH_PROMOTIONS_ERROR = 'FETCH_PROMOTIONS_ERROR'

export const CHECK_PROMOTION_REQUEST = 'CHECK_PROMOTION_REQUEST'
export const CHECK_PROMOTION_SUCCESS = 'CHECK_PROMOTION_SUCCESS'
export const CHECK_PROMOTION_ERROR = 'CHECK_PROMOTION_ERROR'

export const REMOVE_PROMOTION_REQUEST = 'REMOVE_PROMOTION_REQUEST'
export const REMOVE_PROMOTION_SUCCESS = 'REMOVE_PROMOTION_SUCCESS'
export const REMOVE_PROMOTION_ERROR = 'REMOVE_PROMOTION_ERROR'

export const MOVE_TO_WISHLIST_REQUEST = 'MOVE_TO_WISHLIST_REQUEST'
export const MOVE_TO_WISHLIST_SUCCESS = 'MOVE_TO_WISHLIST_SUCCESS'
export const MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS = 'MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS'
export const MOVE_TO_WISHLIST_ERROR = 'MOVE_TO_WISHLIST_ERROR'

export const UNDO_MOVE_TO_WISHLIST_REQUEST = 'UNDO_MOVE_TO_WISHLIST_REQUEST'
export const UNDO_MOVE_TO_WISHLIST_SUCCESS = 'UNDO_MOVE_TO_WISHLIST_SUCCESS'
export const UNDO_MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS = 'UNDO_MOVE_SOLD_OUT_TO_WISHLIST_SUCCESS'
export const UNDO_MOVE_TO_WISHLIST_ERROR = 'UNDO_MOVE_TO_WISHLIST_ERROR'

export const SET_SHIPPING_METHOD_REQUEST = 'SET_SHIPPING_METHOD_REQUEST'
export const SET_SHIPPING_METHOD_SUCCESS = 'SET_SHIPPING_METHOD_SUCCESS'
export const SET_SHIPPING_METHOD_ERROR = 'SET_SHIPPING_METHOD_ERROR'

export const SET_SHIPPING_ADDRESS_REQUEST = 'SET_SHIPPING_ADDRESS_REQUEST'
export const SET_SHIPPING_ADDRESS_SUCCESS = 'SET_SHIPPING_ADDRESS_SUCCESS'
export const SET_SHIPPING_ADDRESS_PARTIAL_ERROR = 'SET_SHIPPING_ADDRESS_PARTIAL_ERROR'
export const SET_SHIPPING_ADDRESS_ERROR = 'SET_SHIPPING_ADDRESS_ERROR'

export const SET_PAYMENT_METHOD_REQUEST = 'SET_PAYMENT_METHOD_REQUEST'
export const SET_PAYMENT_METHOD_SUCCESS = 'SET_PAYMENT_METHOD_SUCCESS'
export const SET_PAYMENT_METHOD_ERROR = 'SET_PAYMENT_METHOD_ERROR'

export const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST'
export const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS'
export const ADD_ADDRESS_ERROR = 'ADD_ADDRESS_ERROR'

export const ADD_CREDIT_CARD_REQUEST = 'ADD_CREDIT_CARD_REQUEST'
export const ADD_CREDIT_CARD_SUCCESS = 'ADD_CREDIT_CARD_SUCCESS'
export const ADD_CREDIT_CARD_ERROR = 'ADD_CREDIT_CARD_ERROR'

export const EDIT_ADDRESS_REQUEST = 'EDIT_ADDRESS_REQUEST'
export const EDIT_ADDRESS_SUCCESS = 'EDIT_ADDRESS_SUCCESS'
export const EDIT_ADDRESS_ERROR = 'EDIT_ADDRESS_ERROR'

export const ADD_PAYMENT_TO_CART_REQUEST = 'ADD_PAYMENT_TO_CART_REQUEST'
export const ADD_PAYMENT_TO_CART_SUCCESS = 'ADD_PAYMENT_TO_CART_SUCCESS'
export const ADD_PAYMENT_TO_CART_ERROR = 'ADD_PAYMENT_TO_CART_ERROR'

export const CLEAR_CART = 'CLEAR_CART'

export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST'
export const CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS'
export const CHECKOUT_ERROR = 'CHECKOUT_ERROR'
export const CHECKOUT_CLEAR_ERROR = 'CHECKOUT_CLEAR_ERROR'

export const SHIPPING_ADDRESS_INVALID = 'SHIPPING_ADDRESS_INVALID'
export const SHIPPING_ADDRESS_VALID = 'SHIPPING_ADDRESS_VALID'

export const FAST_CHECKOUT_REQUEST = 'FAST_CHECKOUT_REQUEST'
export const FAST_CHECKOUT_SUCCESS = 'FAST_CHECKOUT_SUCCESS'
export const FAST_CHECKOUT_ERROR = 'FAST_CHECKOUT_ERROR'

export const ADD_TO_CART_IDENTITY_GENERIC_ERROR = 'ADD_TO_CART_IDENTITY_GENERIC_ERROR'
export const ADD_TO_CART_GENERIC_ERROR = 'ADD_TO_CART_GENERIC_ERROR'

export const SET_PACKAGING_OPTION_REQUEST = 'SET_PACKAGING_OPTION_REQUEST'
export const SET_PACKAGING_OPTION_SUCCESS = 'SET_PACKAGING_OPTION_SUCCESS'
export const SET_PACKAGING_OPTION_ERROR = 'SET_PACKAGING_OPTION_ERROR'

export const SET_CHECKOUT_NOTIFICATION = 'SET_CHECKOUT_NOTIFICATION'
export const RESET_CHECKOUT_NOTIFICATION = 'RESET_CHECKOUT_NOTIFICATION'

export const CLEAR_RECTIFICATION = 'CLEAR_RECTIFICATION'
export const SET_RECTIFICATION = 'SET_RECTIFICATION'

export const ADD_ITEMS_TO_WISHLIST_REQUEST = 'ADD_ITEMS_TO_WISHLIST_REQUEST'
export const ADD_ITEMS_TO_WISHLIST_SUCCESS = 'ADD_ITEMS_TO_WISHLIST_SUCCESS'
export const ADD_ITEMS_TO_WISHLIST_ERROR = 'ADD_ITEMS_TO_WISHLIST_ERROR'

export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'

export const DONATE_TO_CHARITY_REQUEST = 'DONATE_TO_CHARITY_REQUEST'
export const DONATE_TO_CHARITY_SUCCESS = 'DONATE_TO_CHARITY_SUCCESS'
export const DONATE_TO_CHARITY_ERROR = 'DONATE_TO_CHARITY_ERROR'

export const ERR_ORDER_NOT_READY_CHECKOUT = 'ERR_ORDER_NOT_READY_CHECKOUT'

export const KLARNA_EXPRESS_ADD = 'KLARNA_EXPRESS_ADD'
export const KLARNA_EXPRESS_REMOVE = 'KLARNA_EXPRESS_REMOVE'
export const KLARNA_EXPRESS_ERROR = 'KLARNA_EXPRESS_ERROR'

export const SET_AP_ADDRESS_DETAILS = 'SET_AP_ADDRESS_DETAILS'

export const FETCH_USER_SUMMARY_REQUEST = 'FETCH_USER_SUMMARY_REQUEST' 
export const FETCH_USER_SUMMARY_SUCCESS = 'FETCH_USER_SUMMARY_SUCCESS' 
export const FETCH_USER_SUMMARY_ERROR = 'FETCH_USER_SUMMARY_ERROR'